require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-jeff-adelman.json") })
        }
      }, "path---blog-author-jeff-adelman");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-jeff-adelman!./.cache/json/blog-author-jeff-adelman.json
// module id = 652
// module chunks = 231608221292675